export default __webpack_public_path__ + "static/bg10-7b03d2faa5fd295a09a8d910fa849504.jpg";